import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import UpdateAppointmentModal from './UpdateAppointmentModal';

function Information({
  data,
  deleteAppointments,
  getAppointmentsList,
  showAppointment,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleDeleteAppointment = info => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete the appointment for ${_.get(
        data,
        'attributes.appointment_date'
      ) || 'this item'} / ${_.get(data, 'attributes.period') || ''} ?`,
      () => {
        deleteAppointments(info.id, () => {
          getAppointmentsList();
          showAppointment('');
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };
  const handleEdit = info => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateAppointmentModal appointmentData={info} />,
      title: 'Update Appointment',
      modalSize: 'modal-md',
    });
  };

  // const handlePeriod = info => {
  //   if (info === 'AM') {
  //     return '8AM - 11AM';
  //   }
  //   return '1PM - 2PM';
  // };

  return (
    <div className="row mb-3">
      <div className="col-md-12">
        <div className="card p-2">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <div className="font-weight-bold text-center w100">
                Information
              </div>
              {_.get(data, 'id') ? (
                <div>
                  {Acl(permissions, ['EDIT APPOINTMENT GENERAL SETTINGS']) && (
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(data)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  )}
                  {Acl(permissions, [
                    'DELETE APPOINTMENT GENERAL SETTINGS',
                  ]) && (
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleDeleteAppointment(data)}
                      disabled={_.get(data, 'attributes.consumed')}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 ">
              <div className="info-container p-4">
                <div className="row">
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Available Slots:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.available_slot') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Consumed:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.consumed') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Quota:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.quota') || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Date:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {moment(
                            _.get(data, 'attributes.appointment_date')
                          ).format('MM/DD/YYYY') || '---'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Period:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.period') || 'N/A'}
                          {/* ? handlePeriod(_.get(data, 'attributes.period'))
                            : 'N/A'} */}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Type:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.system_module') || '---'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Information.propTypes = {
  getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  deleteAppointments: PropTypes.instanceOf(Function).isRequired,
  showAppointment: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Information);
